<template>
  <div id="printtest"></div>
  <div v-show="showDropdown" ref="dropdown" class="z-20 border-gray-500 absolute p-2 bg-white max-h-96 overflow-y-auto"
    @click="selectDropdown"></div>
  <Transition>
    <TopBanner :mode="bannerMode" :text="bannerText" v-if="bannerText" />
  </Transition>
  <Spinner v-if="loading" />
  <div class="admin-page admin-page--centered relative"
    @mousedown.left="isMouseDown = true" @mouseup="mouseup" @click="generalClick" @keyup.enter="saveSelectedValues()"
    @keyup.esc="generalClick($event, true)">
    <Transition>
      <JobModal v-if="selectedJob" :job="selectedJob" @close="selectedJob = false" :users="allUsers"
        @changeUser="changeUser" />
    </Transition>
    <Transition>
      <ContactDetails v-if="contactDetails" :token="token" :job="contactDetails" @close="contactDetails = false" />
    </Transition>
    <div class="relative w-full text-center print:text-xxs">
      <div class="relative w-full text-center">
        <div class="admin-page-header">
          <div class="admin-page-heading">
            <h1 class="admin-page-title">Auftragsplanung</h1>
            <select class="font-bold text-xl bg-white border border-gray-300 rounded p-1 print:hidden"
              v-model="currentMode" @change="getJobs()">
              <option>Messebasis</option>
              <option>Messestw</option>
              <option>Veranstaltung</option>
              <option>Objektschutz</option>
              <option>Global</option>
              <option>App-Ansicht</option>
            </select>
          </div>
          <div class="hidden lg:block print:hidden">
            <div class="admin-action-bar">
              <button v-if="jobs.length > 0" class="admin-button--secondary" @click="exportCSV()">
                CSV Export
              </button>
              <button v-if="jobs.length > 0 && billingMode" class="admin-button--secondary" @click="printPage()">
                Drucken
              </button>
              <button v-if="jobs.filter(j => j.new).length > 1" class="admin-button--danger" @click="deleteAllNewJobs()">
                Alle Löschen
              </button>
              <button v-if="jobs.filter(j => j.new).length > 1" class="admin-button--primary" @click="saveAllNewJobs">
                Alle Speichern
              </button>
              <button v-if="stats.permissions.admin" class="admin-button--primary" @click="showImportModal = true">
                <i class="fa fa-upload mr-2"></i>Aufträge importieren
              </button>
              <button v-if="stats.permissions.admin" class="admin-button--secondary" @click="showTrashcanModal = true">
                <i class="fa fa-trash mr-2"></i>Papierkorb
              </button>
            </div>
          </div>
        </div>
        <section class="admin-panel mt-5 w-full sm:w-5/6 inline-block text-left">
          <div class="admin-panel__body">
          <span class="block text-2xl font-bold">Filter</span>
          <div class="inline-block p-2 relative">
            <span class="block font-bold mt-2">Projekt</span>
            <div class="absolute right-4 text-2xl bottom-3 text-gray-500 cursor-pointer" @click="filter.project = ''">
              <i class="fa fa-xmark" />
            </div>
            <input size="1" v-model="filter.project" placeholder="Projektname"
              @click="filterDropdown($event, allContracts.map(el => el.name), { type: 'project' })"
              class="dropdown border-b-2 w-64 sm:w-96 p-2 border-gray-500"
              @input="filterDropdown($event, allContracts.map(el => el.name), { type: 'project' })" />
          </div>
          <div class="inline-block p-2">
            <div class="inline-block p-2 acwrapper">
              <span class="block font-bold mt-2">Startdatum ab</span>
              <input size="1" type="date" v-model="filter.start" class="border-b-2 w-36 border-gray-500"
                @change="getJobs" />
            </div>
            <div class="inline-block p-2">
              <span class="block font-bold mt-2">Startdatum bis</span>
              <input size="1" type="date" v-model="filter.end" class="border-b-2 w-36 border-gray-500"
                @change="getJobs" />
            </div>
          </div>
          <button class="admin-button--secondary mx-1 mt-2"
            @click="getJobs()">Suchen</button>
          <button class="admin-button--secondary mx-1 mt-2"
            @click="resetFilter()">Filter zurücksetzen</button>
          <div v-if="meta.results == 1000"><span class="text-red-500 font-bold font-xl pt-3">Maximale Anzahl an
              Ergebnisse erreicht. Bitte Ergebnis durch Filter weiter eingrenzen!</span></div>
          <div class="inline-block align-top px-3">
            <span class="font-bold mt-2">Bedienung</span>
            <span class="block"><b>STRG+Klick</b>: Zeile kopieren</span>
            <span class="block"><b>ALT+Klick</b>: Zeile aus Ansicht löschen (nicht in Navision)</span>
            <span class="block"><b>Doppelklick auf grüne Zeile</b>: Zeile in Navision speichern</span>
            <span class="block"><b>Enter (Markierte Zellen)</b>: Werte speichern</span>
            <span class="block"><b>ESC (Markierte Zellen)</b>: Werte verwerfen</span>
            <span class="block text-red-600"><b>Lfd_Nr</b>: "-" für leere Werte</span>
          </div>
          </div>
        </section>
        <div v-if="searched" class="text-left mt-5">
          <span class="font-bold">Aufträge gefunden: {{ meta.results }}</span><span class="font-bold"> | Summe
            Soll-Stunden: {{ formatFloat(meta.sumSollStunden) }}</span><span class="font-bold"> | Summe
              Ist-Stunden: {{ formatFloat(meta.sumIstStunden) }}</span><span class="font-bold"> | Summe
                geprüfter Ist-Stunden: {{ meta.sumBillableHours }}</span><span class="font-bold"> | Summe Strafen: {{
            meta.sumPenalties }}
            €</span>
        </div>
        <div id="tablecontent" class="overflow-x-auto">
          <table>
            <thead ref="head">
              <th>Aktionen</th>
              <th class="min-w[100px]" v-for="column in modes[currentMode]" :key="column.name"
                :style="columnWidths[column.column] ? { minWidth: columnWidths[column.column] } : {}">{{ column.name }}</th>
            </thead>
            <tbody ref="body">
              <tr id="filterrow" class="border-b-2 border-black print:hidden">
                <td></td>
                <td v-for="column in modes[currentMode]" :key="column.name">
                  <div v-if="!column.noFilter">
                    <select v-if="column.type == 'checkbox'" @change="getJobs" v-model="filter[column.column]">
                      <option value="">Auswählen</option>
                      <option value="true">Ja</option>
                      <option value="false">Nein</option>
                    </select>
                    <input v-else size="1" class="min-w-0 w-full" v-model="filter[column.column]" @change="getJobs()"
                      :placeholder="column.name" />
                  </div>

                </td>
              </tr>
              <tr v-for="job in jobs" :key="job.id" @click.ctrl="duplicateJob(job)" @click.alt="dismissJob(job)"
                @dblclick="createJob(job)" v-bind:class="{ '!bg-green-200': job.new }">
                <td><button class="admin-button--secondary admin-button--sm" @click="duplicateJob(job)">K</button><button class="admin-button--danger admin-button--sm ml-1" v-if="job.new"
                    @click="dismissJob(job)">L</button><button class="admin-button--danger admin-button--sm ml-1" v-if="!job.new && stats.permissions.admin"
                    @click="trashJob(job)" title="In Papierkorb verschieben"><i class="fa fa-trash"></i></button></td>
                <td v-for="column in modes[currentMode]" :key="column.name">
                  <span
                    v-if="column.readonly || (column.column == 'Einsatzort_Beschreibung' && job.Vertragsbeschreibung == '') || (column.column == 'Einsatzstelle_Beschreibung' && job.Einsatzort_Beschreibung == '')">{{
                    (column.column == 'Soll_Stunden' || column.column == 'Ist_Stunden') ? formatFloat(job[column.column]) : job[column.column]
                    }}</span>

                  <input @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    v-else-if="column.column == 'Vertragsbeschreibung'" v-model="job[column.column]" size="1"
                    :placeholder="column.name"
                    @click="filterDropdown($event, findContractNames(), { type: column.column, job: job })"
                    @input="filterDropdown($event, findContractNames(), { type: column.column, job: job })"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    class="dropdown border-b-2 w-full border-gray-500" />

                  <input @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    v-else-if="column.column == 'Einsatzort_Beschreibung'" v-model="job[column.column]" size="1"
                    :placeholder="column.name"
                    @click="filterDropdown($event, findLocationNamesForJob(job), { type: column.column, job: job })"
                    @input="filterDropdown($event, findLocationNamesForJob(job), { type: column.column, job: job })"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    class="dropdown border-b-2 w-full border-gray-500" />
                  <input @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    v-else-if="column.column == 'Einsatzstelle_Beschreibung'" v-model="job[column.column]" size="1"
                    :placeholder="column.name"
                    @click="filterDropdown($event, findPlaceNamesForJob(job), { type: column.column, job: job })"
                    @input="filterDropdown($event, findPlaceNamesForJob(job), { type: column.column, job: job })"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    class="dropdown border-b-2 w-full border-gray-500" />
                  <input @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    v-else-if="column.column == 'Firmenkurzel'" v-model="job[column.column]" size="1"
                    :placeholder="column.name"
                    @click="filterDropdown($event, allCompanies, { type: column.column, job: job })"
                    @input="filterDropdown($event, allCompanies, { type: column.column, job: job })"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    class="dropdown border-b-2 w-full border-gray-500" />
                  <input @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    v-else-if="column.column == 'Leistungsart_Code'" v-model="job[column.column]" size="1"
                    :placeholder="column.name"
                    @click="filterDropdown($event, allServicetypes, { type: column.column, job: job })"
                    @input="filterDropdown($event, allServicetypes, { type: column.column, job: job })"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    class="dropdown border-b-2 w-full border-gray-500" />
                  <input @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    v-else-if="column.column == 'Mitarbeiternr'" v-model="job[column.column]" size="1"
                    :placeholder="column.name"
                    @click="filterDropdown($event, allEmployees, { type: column.column, job: job })"
                    @input="filterDropdown($event, allEmployees, { type: column.column, job: job })"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    class="dropdown border-b-2 w-full border-gray-500" />
                  <div v-else-if="column.type == 'checkbox'" class="text-center">
                    <input :type="column.type" v-model="job[column.column]" size="1" class="min-w-0 w-full"
                      :placeholder="column.name"
                      v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                      :id="job.id + column.column" />
                    <label @click="inputClick($event, job, column.column)"
                      @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                      :for="job.id + column.column" class="inline-block"></label>
                  </div>
                  <div v-else-if="column.column == 'Lfd_Nr'">
                    <input :type="column.type" v-model="job[column.column]" size="1" class="min-w-0 w-full"
                      :placeholder="column.name" @change="onChangedInput(job, column.column)" />
                    <button class="admin-button--secondary admin-button--sm block" v-if="job == jobs[0]" @click="updateLfd(job)">Zählen</button>
                  </div>
                  <input v-else @change="onChangedInput(job, column.column)"
                    @mouseenter="hover($event, job, column.column)" @mouseleave="hover($event, job, column.column)"
                    :type="column.type" v-model="job[column.column]" size="1" class="min-w-0 w-full"
                    :placeholder="column.name"
                    v-bind:class="{ 'marked': selectedJobs.includes(job) && selectedColumn == column.column }"
                    @input="change($event)" @click="inputClick" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button class="admin-button--primary mt-3" @click="jobs.push({ new: true, Zeiterf_Buch_Blattname: currentMode.toUpperCase() })">Job
          hinzufügen</button>
      </div>
    </div>
  </div>
  <JobImportModal
    v-if="showImportModal"
    :allUsers="allUsers"
    :allContracts="allContracts"
    :allCompanies="allCompanies"
    :allServicetypes="allServicetypes"
    :currentJobs="jobs"
    :currentMode="currentMode"
    @close="showImportModal = false"
    @import="handleJobImport"
  />
  <TrashcanModal
    v-if="showTrashcanModal"
    :token="token"
    :isAdmin="stats.permissions.admin"
    @close="showTrashcanModal = false"
    @restored="handleJobRestored"
  />
</template>

<script>
  import CASP from "../../CASP";
  import { useCookies } from "vue3-cookies";
  import JobModal from "@/components/JobModal.vue";
  import ContactDetails from "@/components/ContactDetails.vue";
  import Spinner from "@/components/Spinner";
  import TopBanner from "@/components/TopBanner";
  import JobImportModal from "@/components/JobImportModal.vue";
  import TrashcanModal from "@/components/TrashcanModal.vue";
  import views from "@/lib/views.json";
  import { ALWAYS_HIDDEN_COLUMNS } from "@/lib/jssColumns";
  const filteredViews = Object.fromEntries(
    Object.entries(views).map(([name, columns]) => [
      name,
      columns.filter(column => !ALWAYS_HIDDEN_COLUMNS.has(column.column))
    ])
  );
  let in2Days = new Date()
  in2Days.setDate(in2Days.getDate() + 2)
  let aweekago = new Date()
  aweekago.setDate(aweekago.getDate() - 7)
  export default {
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    name: "Jobs",
    components: { ContactDetails, JobModal, Spinner, TopBanner, JobImportModal, TrashcanModal },
    data() {
      return {
        token: "",
        currentMode: "Messebasis",
        modes: filteredViews,
        filter: {
          project: "",
          start: aweekago.toISOString().split("T")[0],
          end: in2Days.toISOString().split("T")[0]
        },
        printing: false,
        loading: false,
        bannerText: "",
        bannerMode: "success",
        showImportModal: false,
        showTrashcanModal: false,
        allProjects: [],
        allCompanies: [],
        allServicetypes: [],
        allContracts: {},
        allEmployees: {},
        employeeFirmenkurzelMap: {},
        contactDetails: false,
        showDropdown: false,
        showActions: false,
        jobEmployeeDropdown: -1,
        selectedJob: false,
        searched: false,
        dropdownRef: {},
        dropdownInitial: "",
        jobs: [],
        contracts: [],
        billingMode: false,
        meta: {
          results: 0,
          sumBillableHours: 0,
          sumPenalties: 0,
        },
        stats: { permissions: {} },
        isMouseDown: false,
        selectedJobs: [],
        selectedInputs: [],
        selectedColumn: "",
        defaultValues: [],
        justCreated: false,
        newId: 0,
        queryCount:0,
        columnWidths: {}
      };
    },
    methods: {
      handleJobImport(importedJobs) {
        importedJobs.forEach(job => {
          job.id = "new" + this.newId;
          this.newId++;
          this.jobs.push(job);
        });
        this.calculateColumnWidths();
        this.bannerMode = "success";
        this.bannerText = `${importedJobs.length} Aufträge erfolgreich importiert`;
        setTimeout(() => {
          this.bannerText = "";
        }, 3000);
      },
      calculateColumnWidths() {
        const columns = this.modes[this.currentMode];
        const widths = {};
        columns.forEach(col => {
          let maxLen = col.name.length;
          if (col.type === 'text' || col.type === 'number') {
            this.jobs.forEach(job => {
              const val = job[col.column];
              if (val != null && val !== false && val !== true) {
                const len = String(val).length;
                if (len > maxLen) maxLen = len;
              }
            });
          }
          widths[col.column] = Math.max(maxLen + 4, 8) + 'ch';
        });
        this.columnWidths = widths;
      },
      async updateLfd(job) {
        let firstNumber = parseInt(job.Lfd_Nr)
        if (firstNumber) {
          for (let i = 0; i < this.jobs.length; i++) {
            this.jobs[i].Lfd_Nr = firstNumber + i
            if ((firstNumber + i).toString().length == 1) {
              this.jobs[i].Lfd_Nr = "00" + (firstNumber + i)
            } else if ((firstNumber + i).toString().length == 2) {
              this.jobs[i].Lfd_Nr = "0" + (firstNumber + i)
            }
            this.changeJob(this.jobs[i], "Lfd_Nr")
            //await this.changeJobSync(this.jobs[i], "Lfd_Nr")
          }
        }

      },
      findContractNames() {
        return this.allContracts.map(c => c.name)
      },
      findLocationNamesForJob(job) {
        return this.allContracts.find(c => c.name == job.Vertragsbeschreibung)?.locations.map(l => l.name)
      },
      findPlaceNamesForJob(job) {
        return this.allContracts.find(c => c.name == job.Vertragsbeschreibung)?.locations.find(l => l.name == job.Einsatzort_Beschreibung)?.places.map(p => p.name)
      },
      duplicateJob(job) {
        if (["App-Ansicht"].includes(this.currentMode)) {
          this.bannerText = "In dieser Ansicht können keine Aufträge erstellt werden"
          this.bannerMode = "error"
          setTimeout(() => {
            this.bannerText = ""
          }, 2000)
          return

        }
        let dup = JSON.parse(JSON.stringify(job))
        dup.Mitarbeiternr = ""
        dup.Mitarbeitername = ""
        dup.Mitarbeiter_Vorname = ""
        dup.Mitarbeiter_Nachname = ""
        dup.Von_Uhrzeit = ""
        dup.Bis_Uhrzeit = ""
        dup.Ist_Zeiten_geprüft = false
        dup.Bez = false
        dup.VA_Bewachung = false
        dup.VA_Normal = false
        dup.VA_Top = false
        dup.MA_Info = false
        dup.KD_Info = false
        dup.MA_gebucht = false
        dup["MA_bestätigt"] = false
        dup.Mitarbeiter_Nachname = ""
        dup.Lfd_Nr = ""
        dup.Dispo = true
        delete dup.checkedIn
        delete dup.checkinConfirmed
        delete dup.notifiedViaPhone
        delete dup.ma_data
        dup.new = true
        dup.id = "new" + this.newId
        delete dup.Einsatznr
        delete dup.Einsatzzeitnr
        delete dup.Soll_Stunden
        this.newId++
        this.jobs.splice(this.jobs.indexOf(job) + 1, 0, dup)
      },
      dismissJob(job) {
        this.jobs.splice(this.jobs.indexOf(job), 1)
      },
      trashJob(job) {
        let vm = this;
        CASP.deleteJobToTrash(this.token, job.id, (status, res) => {
          if (status === 200) {
            vm.jobs.splice(vm.jobs.indexOf(job), 1);
            vm.bannerMode = "success";
            vm.bannerText = "Auftrag in den Papierkorb verschoben";
            setTimeout(() => { vm.bannerText = ""; }, 3000);
          } else {
            vm.bannerMode = "error";
            vm.bannerText = (res && res.desc) ? res.desc : "Fehler beim Löschen des Auftrags";
            setTimeout(() => { vm.bannerText = ""; }, 5000);
          }
        });
      },
      handleJobRestored(restoredJob, buchBlatt) {
        if (restoredJob) {
          // Switch to the job's Zeiterf_Buch_Blattname mode if not already there
          if (buchBlatt) {
            let modeName = buchBlatt.toLowerCase();
            modeName = modeName.charAt(0).toUpperCase() + modeName.slice(1);
            if (this.currentMode !== modeName && !["Global", "App-Ansicht"].includes(modeName)) {
              this.currentMode = modeName;
            }
          }
          // Add as a new unsaved job with -trash suffix so backend can detect it on save
          let originalId = restoredJob.id;
          restoredJob.id = originalId + "-trash";
          restoredJob.new = true;
          this.jobs.unshift(restoredJob);
          this.calculateColumnWidths();
        }
      },
      clearSelectedJobs() {
        for (let i = 0; i < this.selectedJobs.length; i++) {
          this.selectedJobs[i][this.selectedColumn] = this.defaultValues[i]
        }
        this.selectedJobs = []
      },

      mouseup() {
        setTimeout(() => {
          this.isMouseDown = false
          if (this.selectedJobs.length > 0) {
            let firstInput = this.selectedInputs[0]
            if (firstInput.type != "checkbox") {
              firstInput.click()
              firstInput.select()
            }
            if (firstInput.type == "time") firstInput.showPicker()
            if (firstInput.type == "date") firstInput.showPicker()
          }
        }, 100)

      },
      change(event) {
        if (this.selectedJobs.length > 0) {
          this.selectedJobs.forEach((job) => {
            job[this.selectedColumn] = event.target.value
          })
        }
      },
      hover(event, job, column) {
        if (this.isMouseDown) {
          if (this.selectedJobs.length == 0) {
            this.selectedColumn = column
            this.defaultValues = []
            this.selectedInputs = []
            this.justCreated = true
          } else if (this.selectedColumn != column) {
            return;
          }
          if (!this.selectedJobs.includes(job)) {
            this.selectedJobs.push(job)
            this.defaultValues.push(job[column])
            if (event.target.tagName == "INPUT") {
              this.selectedInputs.push(event.target)
            } else if (event.target.tagName == "LABEL") {
              this.selectedInputs.push(event.target.previousElementSibling)
            }
          }
        }
      },
      inputClick(event, job = false, column = false) {
        event.target.style.width = event.target.scrollWidth + "px"
        if (job) { //when a checkbox is clicked
          let vm = this
          setTimeout(() => {
            if (vm.selectedJobs.length > 0) {
              let newValue = job[column]
              vm.selectedJobs.forEach((j) => {
                j[column] = newValue
                vm.changeJob(j, column)
              })
              vm.selectedJobs = []
            } else {
              vm.changeJob(job, column)
            }
          }, 100)
        }
      },
      resetFilter() {
        this.filter = {
          project: "",
          start: new Date().toISOString().split("T")[0],
          end: in2Days.toISOString().split("T")[0],
          location: "",
          place: "",
          position: "",
          persnr: "",
          accepted: "",
          confirmed: "",
          time_checked: "",
          Bez: "",
          checkinRequired: ""
        }
        this.getJobs()
      },
      filterDropdown(event, data, reference) {
        this.change(event)
        this.dropdownRef = reference;
        let options = "<p class='dp'>-><-</p>";
        let empty = true
        data.forEach((el) => {
          if (el && el.toLowerCase().includes(event.target.value.toLowerCase())) {
            empty = false;
            options += "<p class='dp'>" + el + "</p>";
          }
        });
        if (this.$refs.dropdown) {
          if (!this.showDropdown) {
            this.dropdownInitial = event.target.value
          }
          this.$refs.dropdown.innerHTML = options;
          if (!empty) {
            setTimeout(() => {
              this.showDropdown = true;
              setTimeout(() => {
                event.target.style.width = this.$refs.dropdown.scrollWidth + "px"
              }, 50)
            }, 50)
          }
          event.target.parentNode.appendChild(this.$refs.dropdown)
        }
      },
      selectDropdown(event) {
        if (this.dropdownRef.type == "project") {
          this.filter.project = event.target.innerText
          this.getJobs()
        } else if (this.dropdownRef.job) {
          if (this.selectedJobs.length == 0) {
            this.selectedJobs = [this.dropdownRef.job]
          }
          this.selectedJobs.forEach((job) => {
            if (event.target.innerText == "-><-") job[this.dropdownRef.type] = ""
            else job[this.dropdownRef.type] = event.target.innerText
            if (this.dropdownRef.type == "Vertragsbeschreibung") {
              this.setContract(job, event.target.innerText)
            } else if (this.dropdownRef.type == "Einsatzort_Beschreibung") {
              this.setLocation(job, event.target.innerText)
            } else if (this.dropdownRef.type == "Einsatzstelle_Beschreibung") {
              this.setPlace(job, event.target.innerText)
            } else if (this.dropdownRef.type == "Mitarbeiternr") {
              this.changeUser(job)
            } else {
              this.changeJob(job, this.dropdownRef.type)
            }
          })
        }
        this.dropdownRef.job = null
        this.selectedJobs = []
      },
      async saveSelectedValues(event) {
        if (this.selectedJobs.length > 0) {
          for (let i = 0; i < this.selectedJobs.length; i++) {
            this.onChangedInput(this.selectedJobs[i], this.selectedColumn, true)
          }
        }
        this.selectedJobs = []
      },
      setContract(job, contract) {
        let contractData = this.allContracts.find(c => c.name == contract)
        job.Vertragsbeschreibung = contractData.name
        job.Belegnr = contractData.code
        if (contractData.locations.length == 1) {
          this.setLocation(job, contractData.locations[0].name)
        } else {
          this.changeMultipleAttributes(job, {
            Belegnr: job.Belegnr,
            Einsatzort_Code: "",
            Einsatzstelle_Code: ""
          })
          job.Einsatzort_Beschreibung = ""
          job.Einsatzort_Code = ""
          job.Einsatzstelle_Beschreibung = ""
          job.Einsatzstelle_Code = ""
        }
      },
      setLocation(job, location) {
        let locationData = this.allContracts.find(c => c.code == job.Belegnr).locations.find(l => l.name == location)
        job.Einsatzort_Beschreibung = locationData.name
        job.Einsatzort_Code = locationData.code

        if (locationData.places.length == 1) {
          this.setPlace(job, locationData.places[0].name)
        } else {
          this.changeMultipleAttributes(job, {
            Belegnr: job.Belegnr,
            Einsatzort_Code: job.Einsatzort_Code,
            Einsatzstelle_Code: ""
          })
          job.Einsatzstelle_Beschreibung = ""
          job.Einsatzstelle_Code = ""
        }
      },
      setPlace(job, place) {
        let placeData = this.allContracts.find(c => c.code == job.Belegnr).locations.find(l => l.code == job.Einsatzort_Code).places.find(p => p.name == place)
        job.Einsatzstelle_Beschreibung = placeData.name
        job.Einsatzstelle_Code = placeData.code
        this.changeMultipleAttributes(job, {
          Belegnr: job.Belegnr,
          Einsatzort_Code: job.Einsatzort_Code,
          Einsatzstelle_Code: job.Einsatzstelle_Code
        })
      },
      generalClick(event, close = false) {
        if (!this.justCreated && (close || (event.target.className.includes && !event.target.className.includes("dropdown") && !this.selectedInputs.includes(event.target)))) {
          if (event.target.previousElementSibling && this.selectedInputs.includes(event.target.previousElementSibling)) return
          this.showDropdown = false
          this.clearSelectedJobs()
          if (this.dropdownRef.job) {
            this.dropdownRef.job[this.dropdownRef.type] = this.dropdownInitial
          }
        }
        if (this.justCreated) this.justCreated = false
      },
      exportCSV() {
        let text = ""
        let fields = []
        if (!this.billingMode) {
          text = "Lfd Nr.;Datum;Beginn;Ende;Einsatzort;Einsatzstelle;Position;Mitarbeiter;Angenommen;Bestätigt;Check-In notwendig?"
          fields = [
            "Lfd_Nr",
            "datum_formatted",
            "Soll_Von",
            "Soll_Bis",
            "Einsatzort_Beschreibung",
            "Einsatzstelle_Beschreibung",
            "Pos",
            "Mitarbeiternr",
            "MA_gebucht",
            "MA_bestätigt",
            "checkinRequired"
          ]
        } else {
          text = "Datum;Beginn;Ende;Stunden;Strafen;Einsatzort;Einsatzstelle;Position;Firma;Mitarbeiter;Angenommen;Bestätigt;Zeit geprüft;Bezahlt"
          fields = [
            "datum_formatted",
            "Soll_Von",
            "Soll_Bis",
            "hours",
            "Q",
            "Einsatzort_Beschreibung",
            "Einsatzstelle_Beschreibung",
            "Pos",
            "Firmenkurzel",
            "Mitarbeiternr",
            "MA_gebucht",
            "MA_bestätigt",
            "Ist_Zeiten_geprüft",
            "Bez"]
        }
        this.jobs.forEach(job => {
          text += "\n"
          job.hours = (job.hours + "").replace(".", ",")
          fields.forEach(field => {
            if (job["Ist_Zeiten_geprüft"] && field == "Soll_Von") field = "Von_Uhrzeit"
            if (job["Ist_Zeiten_geprüft"] && field == "Soll_Bis") field = "Bis_Uhrzeit"
            if(job[field]===true) text+="X"
            else if(job[field]===false) text+=""
            else {
              if (field == "Mitarbeiternr"){
                if(job["Mitarbeitername"]){
                  text+=job[field] + " (" + job["Mitarbeitername"] + ")"
                }else{
                  text+=job[field]
                }
              }else{
                text+=job[field]
              }
            }
            text += ";"
          })
        })
        CASP.createXlsxFromCsv(text, (status, res) => {
          let element = document.createElement('a');
          element.setAttribute('href', res.xlsx);
          element.setAttribute('download', new Date().toJSON().split("T")[0] + "_auftraege.xlsx");
          element.style.display = 'none';
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
      },

      changeUser(job) {
        this.selectedJob = false
        let persnr = job.Mitarbeiternr.split(" (")[0]
        let changes = { Mitarbeiternr: persnr }
        // Override Firmenkurzel with the selected employee's Firmenkurzel (if available)
        if (this.employeeFirmenkurzelMap[persnr]) {
          job.Firmenkurzel = this.employeeFirmenkurzelMap[persnr]
          changes.Firmenkurzel = job.Firmenkurzel
        }
        this.changeMultipleAttributes(job, changes);
      },
      getPresets() {
        let vm = this
        CASP.getPresets(this.token, (res) => {
          if (res) {
            vm.allCompanies = res.companies
            vm.allServicetypes = res.Leistungsart_Codes
            vm.allContracts = res.contracts
            vm.allEmployees = []
            vm.employeeFirmenkurzelMap = {}
            Object.keys(res.employees).forEach((el) => {
              vm.allEmployees.push(el + " (" + res.employees[el].name + " " + res.employees[el].surname + ")")
              vm.employeeFirmenkurzelMap[el] = res.employees[el].Firmenkurzel
            })
          }
        })
      },
      onChangedInput(job, column, calledFromMultisave = false) {
        if (!calledFromMultisave && this.selectedJobs.length > 1) {
          return
        } else {
          if ((column == "T_N" && job.Datum_von) || (column == "Datum_von" && job.T_N)) {
            job.T_N = job.T_N.toUpperCase();
            if (job.T_N == "N") {
              let date = new Date(job.Datum_von)
              date.setDate(date.getDate() + 1)
              job.Datum_bis = date.toISOString().split("T")[0]
            } else {
              job.Datum_bis = job.Datum_von
            }
            this.changeMultipleAttributes(job, {
              T_N: job.T_N,
              Datum_von: job.Datum_von,
              Datum_bis: job.Datum_bis
            })
          }
          if (column == "Soll_Von" && job.Datum_von && job.Soll_Bis || column == "Soll_Bis" && job.Datum_von && job.Soll_Bis) {
            let date = new Date(job.Datum_von)
            if (job.Soll_Von > job.Soll_Bis) {
              date.setDate(date.getDate() + 1)
              let changes = {
                Datum_bis: date.toISOString().split("T")[0]
              }
              job.Datum_bis = changes.Datum_bis
              changes[column] = job[column]
              this.changeMultipleAttributes(job, changes)
            } else {
              let changes = {
                Datum_bis: job.Datum_von,
              }
              job.Datum_bis = changes.Datum_bis
              changes[column] = job[column]
              this.changeMultipleAttributes(job, changes)
            }
          }
          else if (["Halle", "Ebene", "Gang", "Stand"].includes(column)) {
            this.generatePosition(job);
            this.changeMultipleAttributes(job, { [column]: job[column], Pos: job.Pos });
          }
          else {
            this.changeJob(job, column)
          }
        }
      },
      changeJob(job, column) {
        if (job.new) return;
        let vm = this
        CASP.changeJob(this.token, job.id, { [column]: job[column] }, (res) => {
          if (res.error) {
            vm.bannerText = res.error
            vm.bannerMode = "error"
            setTimeout(() => {
              vm.bannerText = ""
            }, 5000)
          }

        })
      },
      changeMultipleAttributes(job, changes) {
        if (job.new) return;
        let vm = this
        CASP.changeJob(this.token, job.id, changes, (res) => {
          if (res.error) {
            vm.bannerText = res.error
            vm.bannerMode = "error"
            setTimeout(() => {
              vm.bannerText = ""
            }, 5000)
          }
        })
      },
      deleteAllNewJobs() {
        this.jobs = this.jobs.filter(job => !job.new)
      },
      async saveAllNewJobs() {
        let newJobs = this.jobs.filter(job => job.new)
        for (let i = 0; i < newJobs.length; i++) {
          await this.createJob(newJobs[i])
        }
      },
      createJob(job) {
        return new Promise((resolve, reject) => {
          if (!job.new || job.saving) {
            resolve()
            return
          }
          let missing = []
          if (!job.Ebene){
            if(job.Zeiterf_Buch_Blattname == "MESSESTW") {
              missing.push("Ebene")
            } else {
              job.Ebene="0"
            }
          }
          if (!job.Zähler_Anzahl) missing.push("Zähler_Anzahl")
          if (missing.length > 0) {
            this.bannerText = missing.join(" und ") + " müssen ausgefüllt sein"
            this.bannerMode = "error"
            setTimeout(() => { this.bannerText = "" }, 5000)
            reject()
            return
          }
          let vm = this;
          job.saving = true
          CASP.createJob(this.token, job, (res) => {
            job.saving = false
            if (res && res.error) {
              vm.bannerText = res.error
              vm.bannerMode = "error"
              setTimeout(() => {
                vm.bannerText = ""
                reject()
              }, 5000)
            } else if (!res || typeof res !== "object" || Array.isArray(res) || !res.id) {
              vm.bannerText = "Keine gültige Serverantwort beim Erstellen des Auftrags"
              vm.bannerMode = "error"
              setTimeout(() => {
                vm.bannerText = ""
                reject()
              }, 5000)
            } else {
              vm.jobs[vm.jobs.indexOf(job)] = res
              resolve()
            }
          })
        })
      },
      getUsers() {
        let vm = this;
        CASP.getUsers(this.token, (res) => {
          if (res) {
            vm.allUsers = res;
          }
        });
      },
      filterUsers(job) {
        if (job.id == 0) job.Mitarbeiternr = this.filter.persnr
        this.jobEmployeeDropdown = job.id;
        let vm = this
        let options = "";
        if (job.id == 0) {
          options = "<p class='dp'>Offen</p>";
        }
        this.allUsers.forEach((el) => {
          if (
            this.jobEmployeeDropdown != 0 && el.displayName.toLowerCase().includes(job.Mitarbeiternr.toLowerCase())
          ) {
            options += "<p class='dp'>" + el.displayName + "</p>";
          } else if (
            this.jobEmployeeDropdown == 0 && el.displayName.toLowerCase().includes(this.filter.persnr.toLowerCase())
          ) {
            options += "<p class='dp'>" + el.displayName + "</p>";
          }
        });
        if (this.$refs["jobDropdown" + job.id]) {
          if (this.$refs["jobDropdown" + job.id][0]) this.$refs["jobDropdown" + job.id][0].innerHTML = options;
          else this.$refs["jobDropdown" + job.id].innerHTML = options;
        }

      },
      formatFloat(value) {
        if (value === null || value === undefined || value === '') return value;
        let formatted = parseFloat(value).toFixed(2).replace('.', ',');
        if (parseFloat(value) < 10 && parseFloat(value) >= 0) {
          formatted = '0' + formatted;
        }
        return formatted;
      },
      generatePosition(job) {
        if (this.currentMode !== 'Messestw') return;
        let pos="";
        if (job.Halle) pos=`Halle ${job.Halle}`;
        if (job.Ebene) pos+=`.0${job.Ebene}`;
        if (job.Stand) pos+=` Stand ${job.Gang}${job.Stand}`;
        job.Pos = pos;
      },
      printPage() {
        this.showActions = false
        setTimeout(() => { print() }, 500)

      },
      getJobs() {
        this.loading = true;
        this.columnWidths = {};
        let vm = this;
        this.filter.Zeiterf_Buch_Blattname = this.currentMode.toUpperCase()
        if (["Global", "App-Ansicht"].includes(this.currentMode)) {
          delete this.filter.Zeiterf_Buch_Blattname
        }
        if (this.connection) {
          this.connection.send(JSON.stringify({ type: "init", token: this.token, filter: this.filter }))
        }
        this.jobs = []
        CASP.getAdminJobs(
          this.token,
          this.filter,
          (res) => {
            vm.queryCount++;
            if (res && res.meta) vm.meta = res.meta
            vm.jobs = []
            vm.searched = true;
            vm.loading = false;
            function push(data, index, initialQueryCount) {
              setTimeout(() => {
                if(initialQueryCount != vm.queryCount) return;
                if (index < data.length) {
                  vm.jobs.push(data[index])
                  push(data, index + 1, initialQueryCount)
                } else {
                  vm.calculateColumnWidths()
                }
              }, 1)
            }
            push(res.jobs, 0, vm.queryCount)
          }
        );
      },
      startSocket() {
        const vm = this
        this.connection = new WebSocket(process.env.VUE_APP_WS_URL + '/updates')
        this.connection.onopen = function (event) {
          setTimeout(() => {
            vm.connection.send(JSON.stringify({ type: "init", token: vm.token, filter: vm.filter }))
          }, 500)

        }
        this.connection.onmessage = function (event) {
          let data = JSON.parse(event.data)
          if (data.type === "checkin") {
            vm.showCheckin(data.job)
            let newJobs = []
            vm.jobs.forEach((job) => {
              if (job.id == data.job.id) {
                newJobs.push(data.job)
              } else {
                newJobs.push(job)
              }
            })
            vm.jobs = newJobs;
          } else if (data.type == "update") {
            for (let i = 0; i < vm.jobs.length; i++) {
              if (vm.jobs[i].id == data.job.id) {
                vm.jobs[i] = data.job
                vm.jobs[i].new = true
                setTimeout(() => {
                  vm.jobs[i].new = false
                }, 1000)
              }
            }
          }
        }
      },
    },
    computed: {
      today: function () {
        let d = new Date().toISOString().split("T")[0].split("-");
        return d[2] + "." + d[1] + "." + d[0];
      },
      datestamp: function () {
        return new Date().toISOString().split("T")[0] + "00:00:00";
      },
    },
    mounted: function () {
      let vm = this
      window.vm = vm
      this.modes["Global"].forEach((el) => {
        this.filter[el.column] = "";
      })
      document.getElementById("mainspinner").style.display = "none";
      
        CASP.isAuthenticated(this.token, (auth) => {
          if (!auth) {
            window.location = "/admin/login";
          } else {
            this.getPresets();
            this.getUsers();
            this.getJobs();
            this.startSocket();
            CASP.getStats((status, response) => {
              if (status == 200) {
                vm.stats = response
              }
            })
          }
        });
      
    },
  };
</script>
<style scoped>
  .marked {
    background: yellowgreen;
  }

  #filterrow td {
    border-bottom: 2px solid black;
  }

  tr {
    page-break-inside: avoid;
  }

  @region {
    size: auto;
  }

  @region table {
    break-before: avoid;
  }

  table {
    page-break-before: auto;
    /* or always, avoid */
    page-break-after: auto;
    /* or always, avoid */
  }

  td {
    @apply whitespace-nowrap border border-gray-300;
  }

  /* Keep the normalized admin buttons compact inside table cells */
  td button {
    @apply py-1 px-2 text-sm;
    min-height: 0;
    line-height: 1.2;
  }

  @media print {
    #printtest {
      display: none
    }

    button {
      display: none
    }

    td,
    th {
      padding: 2px;
      margin: 2px;
      max-width: 75px;
      white-space: normal;
      word-break: break-word;

    }
  }

  th {
    padding: 4px;
    margin: 2px;
    min-width: 75px;
    white-space: nowrap;
    word-break: break-word;
  }
</style>